
<template>

    <b-container class="bv-example-row bv-example-row-flex-cols" 
    style="padding:0px;height: 100vh !important;max-width: 5000px !important;">

        <b-row style="height: 100vh;background-color: white;">
            
            <b-col xs="0" lg="6" class="d-none d-lg-block">
                <b-row style="height: 100% !important;align-content: center !important;">
                    <b-col sm="12" md="auto" style="width: 100% !important;">
                        <img height="100" src="../assets/images/logo_deskontime.png" style="margin-left: auto;margin-right: auto;display: block;padding:10px;">
                    </b-col>
                    <b-col sm="0" md="auto">
                    </b-col>
                </b-row>                
            </b-col>
            
            <b-col xs="12" lg="6" style="background: url(https://bckt-front-desk.s3.us-east-2.amazonaws.com/front-desk-wallpaper.jpg);background-repeat: no-repeat;background-size: cover;background-position: left;background-position-y: bottom;">

                <b-row align-v="center" style="height: 100%;justify-content: center;padding: 20px !important;">
                
                    <div style="border-radius: 5px;background-color: white;padding: 4rem 3.5rem 3rem 3.5rem;max-width: 450px;width: 100% !important;min-height: 400px;">
                        
                        <div>
                            
                            <h1 class="font-clean-title">Restablecer Contraseña</h1>
                            <p class="font-clean-text">Ingrese una nueva contraseña</p>

                            <form class="mb-3" @submit.prevent="validateBeforeSubmit('login')" data-vv-scope="login">

                                <div class="form-group">
                                    <label class="font-clean-label" style="margin-top: 10px;margin-bottom: 0px;" for="browser_first_name">Nueva Contraseña</label>
                                    <b-form-input required v-model="login.password" v-validate="'required'" type="password" name="password" ref="password" class="font-clean-text"
                                    :disabled="isLoading" style="margin-top: 0px;border-radius: 5px;font-size: 16px;font-weight: 500;color: #191d23b3 !important;"/>
                                </div>

                                <div class="form-group">
                                    <label class="font-clean-label" style="margin-top: 10px;margin-bottom: 0px;" for="browser_first_name">Confirmar Nueva Contraseña</label>
                                    <b-form-input required v-model="login.password_confirm" v-validate="(login.password.length> 0)?'required|confirmed:password':''" type="password" 
                                        name="password_confirm" ref="password_confirm"
                                        :class="{'form-control':true, 'is-invalid': errors.has('login.password_confirm')}" 
                                    :disabled="isLoading" style="margin-top: 0px;border-radius: 5px;font-size: 16px;font-weight: 500;color: #191d23b3 !important;"/>
                                    <span v-show="errors.has('login.password_confirm')" class="invalid-feedback">{{ errors.first('login.password_confirm') }}</span>
                                </div>

                                <button v-if="!isLoading" class="btn btn-block font-clean-text btn-login-color" type="submit" :disabled="isLoading" 
                                    style="border-radius: 5px;margin-top: 30px;color: white;">Continuar
                                </button>
                                <button v-if="isLoading" class="btn btn-block font-clean-text btn-login-color" style="margin-top: 30px;" disabled>
                                    <b-spinner small style="margin-right:5px;color: white;"></b-spinner>Cargando...
                                </button>
                            </form>
                            
                            <br/>
                            <span class="font-clean-text" style="display: block;text-align: center;">&copy; {{ new Date().getFullYear() }} - Sad Corp S.A.C.</span>
                        </div>
                    </div>
                    
                </b-row>
        </b-col>

    </b-row>
        
  </b-container>

</template>

<script>

  import Vue from 'vue'
  import * as VeeValidate from 'vee-validate';
  import router from '../router'
  
  Vue.use(VeeValidate, {
    fieldsBagName: 'formLogin'  
  })

  export default { 
    data() {
      return {
        login: {
          email: '',
          password: '',
          password_confirm: '',
          error: ''
        },
        isLoading: false
      }
    },  
    created () {
      localStorage.csrf = router.currentRoute.params.token
      this.login.email = router.currentRoute.params.user_id
    },
    methods: {
      validateBeforeSubmit(scope) {
        this.isLoading = true;
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.update();
          }else{
            this.isLoading = false;
            this.showError("Debe completar los campos requeridos")
          }
        });
      },
      update () {
        try {
            this.$http.plain.post('/auth/v1/login', { type: "restore_password", platform: "desk", email: this.login.email, password: this.login.password })
            .then(response => this.signinSuccessful(response))
            .catch(error => this.signinFailed(error))                    
        } catch (err) {
            this.isLoading = false;
            this.showError(err)
        }
      },
      signinSuccessful (response) {

        console.log(response)
        localStorage.clear()
        this.showOK("Se restableció la contraseña correctamente!")
        this.$router.push('/auth/login')
      },
      signinFailed (error) {

          var e = '';
          if(error){
          if(error.data){
              if(error.data.error){
              e = error.data.error;
              } else{
              e = error.data;
              }   
          }else{
              e = error;
          }
          }else{
          e = 'error';
          }
          
          localStorage.clear()

          this.showError(e)
          this.isLoading = false;
          
      },
    }
  }

</script>
